<template>
  <section>
    <div class="container">
      <div class="row mb-5">
        <div class="col-2">
          <v-icon
            icon="chevron-left"
            class="cursor-pointer"
            @click="() => $router.back()"
          />
        </div>
        <div class="col-8 text-center mb-auto">
          <h1>Vos documents</h1>
          <div class="lead fw-bold">
            {{ productName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <v-display
            v-for="contract in contractsByProductId"
            :key="contract.id"
            :contract="contract"
            class="mb-2"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import ContractDisplay from './helpers/ContractDisplay.vue';

export default {
  name: 'DocumentByProductView',
  components: {
    'v-display': ContractDisplay,
  },
  computed: {
    ...mapGetters({
      contracts: 'contracts/get',
      products: 'rater/products',
    }),
    productId() {
      return parseInt(this.$route.params.productId, 10);
    },
    productName() {
      return (this.products
        .find(({ id }) => id === this.productId)
        || { name: 'Contrat' })
        .name;
    },
    contractsByProductId() {
      return this.contracts
        .filter(({ productId }) => productId === this.productId)
        || [];
    },
  },
};
</script>

<style scoped>
.flip-list-move {
  transition: transform 1s;
}
</style>
